import { render, staticRenderFns } from "./PayRangeEditor.vue?vue&type=template&id=70858f44&scoped=true"
import script from "./PayRangeEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./PayRangeEditor.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PayRangeEditor.vue?vue&type=style&index=0&id=70858f44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70858f44",
  null
  
)

export default component.exports